module.exports = __webpack_public_path__ + "media/buzzer_takeaway_selfservice.d68d8113.webm";